var map = {
	"./distributor/router/index.js": [
		"023f",
		"chunk-2d0a350b"
	],
	"./shopping/index/router/index.js": [
		"d06d",
		"chunk-2d21d130"
	],
	"./shopping/login/router/index.js": [
		"0bfe",
		"chunk-2d0aef67"
	],
	"./shopping/storeList/router/index.js": [
		"7977",
		"chunk-2d0d7e38"
	],
	"./supplier/router/index.js": [
		"d67a"
	],
	"./yms/router/index.js": [
		"7dc7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "bc71";
module.exports = webpackAsyncContext;